<!-- FICHA RÁPIDA DE LA TANDA (FTA-01; Mario, 14-oct). Panel lateral, como la de la liquidación. -->
<div class="fixed inset-0 z-[60] flex justify-end bg-black/30" (click)="cerrar.emit()" (keydown.escape)="cerrar.emit()">
  <aside class="flex h-full w-full max-w-md flex-col overflow-y-auto bg-background shadow-xl" (click)="$event.stopPropagation()"
         role="dialog" aria-modal="true" [attr.aria-label]="'Tanda ' + ficha.n">
    <header class="flex items-start justify-between gap-3 border-b border-border px-5 py-4">
      <div class="min-w-0">
        <p class="kb-td-sub m-0">Tanda del cierre {{ fecha(dia) }}</p>
        <h3 class="m-0 flex items-center gap-2 text-base font-semibold">Tanda {{ ficha.n }}<span class="kb-badge kb-badge-neutro" *ngIf="ficha.tipo === 'REINTENTO'">Reintento</span></h3>
      </div>
      <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="cerrar.emit()" aria-label="Cerrar">✕</button>
    </header>
    <div class="flex flex-col gap-5 px-5 py-4 text-sm">
      <p *ngIf="cargando" class="kb-td-sub m-0">Leyendo la tanda…</p>
      <div *ngIf="error" class="kb-aviso-peligro">{{ error }}</div>
      <ng-container *ngIf="!cargando && !error && ficha.avance">
        <div class="flex flex-wrap items-end justify-between gap-2">
          <div>
            <p class="m-0 text-2xl font-semibold tabular-nums">$ {{ ficha.monto | number:'1.2-2':'es' }}</p>
            <p class="kb-td-sub m-0" *ngIf="ficha.tasa">Bs {{ (ficha.monto * ficha.tasa) | number:'1.2-2':'es' }} · tasa {{ ficha.tasa | number:'1.2-2':'es' }}</p>
          </div>
          <span [ngClass]="claseAvance(ficha.avance)"><i class="fas mr-1" [ngClass]="iconoAvance(ficha.avance)" aria-hidden="true"></i>{{ ficha.avance.texto }}</span>
        </div>

        <section>
          <h4 class="m-0 mb-2 text-sm font-semibold">Comercios · {{ ficha.comercios.length }}</h4>
          <ul class="m-0 flex list-none flex-col gap-2 p-0">
            <li class="rounded-lg border border-border p-3" *ngFor="let c of ficha.comercios">
              <div class="flex items-center justify-between gap-2">
                <app-estampa-comercio [codigo]="c.code" [tam]="24" [conNombre]="true"></app-estampa-comercio>
                <b class="tabular-nums">$ {{ c.neto | number:'1.2-2':'es' }}</b>
              </div>
              <div class="mt-2 flex flex-wrap items-center justify-between gap-2">
                <span [ngClass]="clasePago(c.pago)"><i *ngIf="iconoPago(c.pago)" class="fas mr-1" [ngClass]="iconoPago(c.pago)" aria-hidden="true"></i>{{ c.pago?.texto || '—' }}</span>
                <button type="button" *ngIf="c.liquidacion" class="kb-td-mono underline decoration-dotted underline-offset-2 hover:decoration-solid" (click)="fichaLiq.abrir(c.liquidacion)">{{ c.liquidacion }}</button>
              </div>
              <p class="kb-td-sub m-0 mt-1">cuenta por pagar {{ c.cuenta_por_pagar }}</p>
            </li>
          </ul>
        </section>

        <section>
          <h4 class="m-0 mb-2 text-sm font-semibold">Aprobación</h4>
          <dl class="m-0 grid grid-cols-[110px_1fr] gap-x-3 gap-y-2">
            <dt class="kb-td-sub m-0">Banda</dt><dd class="m-0">{{ ficha.banda?.n || '—' }}<span class="kb-td-sub" *ngIf="ficha.bandas_version"> · {{ ficha.bandas_version }}</span></dd>
            <dt class="kb-td-sub m-0">Preparada</dt><dd class="m-0">{{ ficha.preparada_por || '—' }}<span class="kb-td-sub"> · {{ hora(ficha.preparada_en) }}</span></dd>
            <ng-container *ngFor="let f of ficha.firmas"><dt class="kb-td-sub m-0">Firma</dt><dd class="m-0">{{ f.quien }} · {{ ROL[f.rol] || f.rol }}<span class="kb-td-sub"> · {{ hora(f.en) }}</span></dd></ng-container>
            <ng-container *ngIf="ficha.devuelta"><dt class="kb-td-sub m-0">Devuelta</dt><dd class="m-0 text-amber-700">{{ ficha.devuelta.motivo }}</dd></ng-container>
            <!-- FIR-02: el correo a quien le toca firmar -->
            <ng-container *ngIf="esperaFirma">
              <dt class="kb-td-sub m-0">Aviso de firma</dt>
              <dd class="m-0">
                <span *ngIf="ficha.aviso_firma?.ok">Enviado a {{ ficha.aviso_firma.para.join(', ') }}<span class="kb-td-sub"> · {{ hora(ficha.aviso_firma.en) }}</span></span>
                <span *ngIf="ficha.aviso_firma && !ficha.aviso_firma.ok" class="text-amber-700">No se pudo enviar: {{ ficha.aviso_firma.error }}</span>
                <span *ngIf="!ficha.aviso_firma" class="kb-td-sub">Todavía no se envió</span>
                <button type="button" *ngIf="puedeReenviar" class="kb-btn kb-btn-outline kb-btn-sm !w-auto mt-1.5 block" [disabled]="reenviando" (click)="reenviar()">{{ reenviando ? 'Enviando…' : 'Reenviar aviso' }}</button>
                <span class="kb-td-sub block" *ngIf="resultado">{{ resultado }}</span>
              </dd>
            </ng-container>
          </dl>
        </section>

        <section>
          <h4 class="m-0 mb-2 text-sm font-semibold">Lotes · {{ ficha.lotes.length }}</h4>
          <p class="kb-td-sub m-0" *ngIf="!ficha.lotes.length">Todavía no se armó el lote de esta tanda.</p>
          <ul class="m-0 flex list-none flex-col gap-2 p-0">
            <li class="flex items-start justify-between gap-2 rounded-lg border border-border p-3" *ngFor="let lo of ficha.lotes">
              <div class="min-w-0">
                <p class="m-0 font-mono text-xs">{{ lo.code }}</p>
                <p class="kb-td-sub m-0">{{ lo.state === 'ANULADO' ? 'Anulado' : (lo.pagados + ' pagado(s)' + (lo.no_procesados ? ' · ' + lo.no_procesados + ' no procesado(s)' : '') + ' · $ ' + (lo.monto | number:'1.2-2':'es')) }}</p>
                <p class="kb-td-sub m-0" *ngIf="lo.referencias.length">ref. {{ lo.referencias.join(', ') }}</p>
              </div>
              <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto shrink-0" (click)="verLote.emit(lo.code)">Ver lote</button>
            </li>
          </ul>
        </section>
      </ng-container>
    </div>
  </aside>
</div>
